export default "__VITE_ASSET__42a8a8c3__"